import React, { useEffect, useState } from "react";
import { LANDING } from "@/constants/testIds";

export default function StickyMobileCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = () =>
    document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" });

  if (!show) return null;

  return (
    <div
      data-testid={LANDING.stickyMobileCta}
      className="fixed bottom-3 left-3 right-3 z-30 md:hidden bg-white rounded-full border border-black/10 shadow-2xl px-3 py-2 flex items-center gap-3"
    >
      <div className="w-10 h-10 bg-[#f5f4f1] rounded-full overflow-hidden flex-shrink-0">
        <img
          src="/assets/Almohada_1_Mejorada.png"
          alt="Dubai Pillow"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[13px] font-bold leading-tight text-[#0e0e10]">
          Dubai Pillow
        </div>
        <div className="text-[11px] text-[#8a8a8a]">
          <span className="font-bold text-[#0e0e10]">From $74</span><span className="text-[10px]">/pillow</span>
          {" · "}
          <span className="text-[#22c55e] font-semibold">Save up to $499</span>
        </div>
      </div>
      <button onClick={scrollTo} className="pill-btn text-[12px] py-2.5 px-4 flex-shrink-0">
        Take a look →
      </button>
    </div>
  );
}
